<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div>
        <div v-if="role===0 || role===1" class="table-top-wrapper">
            <el-row>
                <el-col :span="24" class="condition-panel"
                        style="display: flex;flex-direction: row;justify-content: space-between;">
                    <el-col :span="2">
                    </el-col>
                    <el-col :span="22" style="display: flex;flex-direction: row;justify-content: end;">
                        <el-form :inline="true">
                            <el-form-item label="发布者" style="margin-right: 10px !important;">
                                <el-input @input="getComment(true)" v-model="trendCommentSelect.trendComment.userId"
                                          type="number"></el-input>
                            </el-form-item>
                            <el-form-item label="评论时间" style="margin-right: 10px !important;">
                                <el-date-picker
                                        v-model="trendCommentSelect.trendComment.createTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择评论时间"
                                        default-time="12:00:00">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="margin-left: 20px;" @click="reset()" type="danger">重置</el-button>
                                <el-button style="margin-left: 20px;" @click="getComment(true)" type="primary">查询
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-col>
            </el-row>
        </div>

        <div class="table-wrapper">
            <el-table
                    :header-cell-style="$store.state.style.table.headerCellStyle"
                    :cell-style="$store.state.style.table.cellStyle"
                    :header-row-style="$store.state.style.table.headerRowStyle"
                    :row-style="$store.state.style.table.rowStyle"
                    :row-class-name="tableClass"
                    border
                    key="CommentManage"
                    width="100%"
                    :data="trendComments">
                <el-table-column label="ID" prop="id"></el-table-column>
                <el-table-column label="内容" prop="content"></el-table-column>
                <el-table-column label="游记ID" prop="itemId"></el-table-column>
                <el-table-column label="发布者" prop="user.name"></el-table-column>
                <el-table-column label="评论时间" prop="createTime"></el-table-column>
                <el-table-column width="380" label="操作">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: center;flex-direction: row">
                            <el-button v-if="role===0" type="primary" @click="handleCommentDialog(2,scope.row)"
                                       icon="el-icon-edit"></el-button>
                            <el-popover
                                    v-if="role===0 && scope.row.role !==0"
                                    placement="top"
                                    key="CommentManage"
                                    style="margin-left: 10px"
                                    v-model="scope.row.visible">
                                <p style="text-align: center">真的要删除吗?</p>
                                <div>
                                    <el-button type="danger" @click="deleteComment(scope.row,scope.$index)">确定
                                    </el-button>
                                    <el-button type="success" @click="scope.row.visible=false">取消</el-button>
                                </div>
                                <el-button icon="el-icon-delete" type="danger" slot="reference"></el-button>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pg-wrapper">
                <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="trendCommentSelect.pageVo.pageIndex"
                        :page-size.sync="trendCommentSelect.pageVo.pageSize"
                        @size-change="getComment(false)"
                        @current-change="getComment(false)"
                        :page-sizes="[5, 10, 50, 100]"
                        :total.sync="trendCommentSelect.pageVo.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="trendCommentDialogVisible" width="40%" :close-on-click-modal="false">
            <el-form label-width="150px" label-position="left" :model="trendComment">
                <el-form-item label="内容" style="margin-right: 10px !important;">
                    <el-input v-model="trendComment.content" type="text"></el-input>
                </el-form-item>
                <el-form-item label="游记ID" style="margin-right: 10px !important;">
                    <el-input v-model="trendComment.itemId" type="number"></el-input>
                </el-form-item>
                <el-form-item label="发布者" style="margin-right: 10px !important;">
                    <el-input v-model="trendComment.userId" type="number"></el-input>
                </el-form-item>
                <el-form-item label="评论时间" style="margin-right: 10px !important;">
                    <!--HH:mm:ss-->
                    <el-date-picker
                            v-model="trendComment.createTime"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择评论时间"
                            default-time="12:00:00">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           <el-button @click="trendCommentDialogVisible = false">取消</el-button>
           <el-button type="primary" @click="handleCommentDialogConfirm">保存</el-button>
       </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "CommentManage",
    watch: {},
    data() {
        return {
            isFullscreen: false,
            fullscreenImage: '',
            role: this.$store.state.loginUser.role,
            trendCommentSelect: {
                trendComment: {
                    type: '',
                    itemId: 0,
                    userId: 0,
                    createTime: '',
                },
                pageVo: {
                    pageSize: 5,
                    pageIndex: 1,
                    total: 0
                }
            },
            trendComment: {
                id: null,
                type: '',
                content: '',
                itemId: 0,
                userId: 0,
                createTime: '',
            },
            trendComments: [],
            selectedTrendComment: {},
            trendCommentDialogMode: 1,
            trendCommentDialogVisible: false,
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    methods: {
        openFullscreen(image) {
            this.fullscreenImage = image;
            this.isFullscreen = true;
        },
        closeFullscreen() {
            this.isFullscreen = false;
            this.fullscreenImage = '';
        },
        reset() {
            this.trendCommentSelect.trendComment = {}
            this.getComment(true)
        },
        //crud
        insertComment() {
            let data = JSON.stringify(this.trendComment)
            this.$axios({
                url: "/trendComment/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    this.trendComment.id = r.data
                    this.trendComments.push(this.trendComment)
                    this.trendCommentSelect.pageVo.total++
                    this.$message.success('创建成功');
                } else {
                    this.$message.error('创建失败');
                }
            })
        },
        deleteComment(comment, index) {
            this.$axios({
                url: "/trendComment/delete?id=" + comment.id,
                method: 'get',
                headers: {'content-type': 'application/json'},
            }).then((r) => {
                if (r.data === 1) {
                    this.trendComments.splice(index, 1)
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('删除失败');
                }
            })
        },
        modifyComment() {
            let data = JSON.stringify(this.comment)
            this.$axios({
                url: "/trendComment/update",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data === 1) {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
            })
        },
        getComment(resetPageIndex) {
            if (resetPageIndex) {
                this.trendCommentSelect.pageVo.pageIndex = 1
            }
            let data = JSON.stringify(this.trendCommentSelect)
            this.$axios({
                url: "/trendComment/select",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                this.trendComments = r.data.trendComments
                this.trendCommentSelect.pageVo.total = r.data.total
            })
        },
        //crud public
        handleCommentDialog(mode, comment) {
            this.commentDialogMode = mode
            this.commentDialogVisible = true
            if (mode === 1) {
                this.trendComment = {
                    id: null,
                    type: '',
                    content: '',
                    itemId: 0,
                    userId: 0,
                    createTime: '',
                }
            }
            if (mode === 2) {
                this.trendComment = comment
            }
        },
        handleCommentDialogConfirm() {
            if (this.commentDialogMode === 1) this.insertComment()
            if (this.commentDialogMode === 2) this.modifyComment()
            this.commentDialogVisible = false
        },

        //common
        tableClass({row, rowIndex}) {
            return rowIndex % 2 === 1 ? "even-row" : "no-even-row"
        },
    },
    mounted() {
        this.reset()
    },
}
</script>
<style scoped>
.el-radio-button__inner {
    border: 0 !important;
    border-radius: 0 !important;
    /*background-color: transparent !important;*/
}

.fullscreen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.fullscreen-image {
    max-width: 90%;
    max-height: 90%;
}

</style>